module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/node_modules/core-js/modules/_iterators.js
// module id = 62
// module chunks = 10